import React, { useState, useEffect } from "react";
import SchoolHeader from "../components/SchoolHeader";
import Footer from "../components/Footer";
import {
    Container,
    Card,
    Form,
    Row,
    Col,
    Button,
    Modal,
} from "react-bootstrap";
import { FaEye, FaTrashAlt, FaUndoAlt } from "react-icons/fa";
import { DataGrid } from "@mui/x-data-grid";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import schoolServices from "../services/school_services";
import { useParams } from "react-router-dom";
import moment from 'moment'

const PendingApproval = () => {
    const { id } = useParams()
    const [value1, setValue1] = React.useState(null);
    const [value2, setValue2] = React.useState(null);
    const [value, onChange] = useState(new Date());
    const [UtilityList, setUtilityList] = useState({ allRotationReq: [] })

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);

    const columns = [
        { field: "hospitalInfo", headerName: "Hospital", sortable: false, width: 130 },
        {
            field: "departmentInfo",
            headerName: "Type of rotation",
            sortable: false,
            width: 130,
        },
        {
            field: "date",
            headerName: "Date",
            sortable: false,
            width: 185,
        },
        {
            field: "time",
            headerName: "Time",
            sortable: false,
            width: 185,
        },
        {
            field: "day",
            headerName: "Days For rotation",
            sortable: false,
            width: 300,
        },
        {
            field: "status",
            headerName: "Approval Status",
            sortable: false,
            width: 150,
            renderCell: (params) => {
                return (
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        {
                            params?.value === "approved" ?
                                <Chip label="Approved" size="small" color="success" /> :
                                params?.value === "disapproved" ?
                                    <Chip label="Rejected" size="small" color="error" /> :
                                    <Chip label="Under review" size="small" color="primary" />
                        }
                    </div>
                );
            },
        }
    ];

    const rows = [
        {
            id: 1,
            hospital: "Antelope Valley Medical Center ",
            rotation: "Medical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 2,
            hospital: "MLK Jr Hospital",
            rotation: "Surgical",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 3,
            hospital: "SCH-Culver City ",
            rotation: "Mental Health",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Under review",
        },
        {
            id: 4,
            hospital: "Foothill Regional Medical Center",
            rotation: "Pediatrics",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
        {
            id: 5,
            hospital: "College Medical Center",
            rotation: "OB",
            date: "12/11/2022 -  18/11/2022",
            hours: "9 a.m.-6 p.m.",
            status: "Rejected",
        },
    ];


    const getAllRotationReq = async (argData) => {
        // setLoading(true)
        // let data = {
        //     schoolId: id,
        //     RotationDate: "",
        //     query: "",
        // }

        await schoolServices.getAllRotationReq({ schoolId: argData }).then(resp => {
            // setUtilityList(prev => ({ ...prev, "allRotationReq": [] }))
            resp.data.data.map(curr => {
                curr.id = curr._id
                curr.day = curr.days.map(curr => { return curr })
                curr.hospitalInfo = curr.hospitalInfo.hospital_name
                curr.departmentInfo = curr.departmentInfo.department
                curr.date = `${moment(curr.start_date).format("MM/DD/YYYY")} - ${moment(curr.end_date).format("MM/DD/YYYY")}`
                curr.time = `${curr.start_time}-${curr.end_time}`
                setUtilityList(prev => ({ ...prev, "allRotationReq": [...prev.allRotationReq, curr] }))
            })
        }
        ).catch(err => {
            // setLoading(false)
            console.log(err)
        })
    }

    useEffect(() => {
        getAllRotationReq(id)
    }, [])

    return (
        <div className="dashbrd_pg">
            <SchoolHeader />
            {console.log(id, "id")}
            {console.log(UtilityList.allRotationReq, "UtilityList?.allRotationReq")}
            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    <div className="prfl_wrap">
                        <div className="pg_hdng mb-4">
                            <h2>Pending Approvals</h2>
                        </div>
                        <Card className="pg_card">
                            <Card.Body>
                                <div className="card_hdng ">
                                    <h4 className="mb-0">Pending Approvals</h4>
                                </div>
                                <div className="apprvl_list">
                                    <div
                                        style={{
                                            height: 400,
                                            width: "100%",
                                        }}
                                    >
                                        <DataGrid
                                            rows={UtilityList?.allRotationReq}
                                            columns={columns}
                                            pageSize={5}
                                            rowsPerPageOptions={[5]}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Container>
            </div>
            <Footer />

            <Modal show={show} onHide={handleClose} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Rotation Request
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="dbbsc_info p-2 rttn_info">
                        <p className="stdntbsc_inf">
                            <strong>Hospital:</strong> Antelope Valley Medical
                            Center
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Date:</strong> 12/11/2022 - 18/11/2022
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Time:</strong> 9 a.m.-6 p.m.
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Course Objective:</strong> Lorem ipsum
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Message:</strong> Lorem ipsum dolor sit
                            amet, consectetur adipisicing elit. Repellendus
                            architecto dolor totam.
                        </p>
                        <p className="stdntbsc_inf">
                            <strong>Approval Status:</strong>{" "}
                            <Chip
                                label="Under review"
                                color="primary"
                                size="small"
                                className="schl_bdg"
                            />
                        </p>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={show1} onHide={handleClose1} className="main_modl">
                <Modal.Header closeButton>
                    <Modal.Title className="text_theme">
                        Reschedule Rotation Request
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="prfl_flds">
                        <Form>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Select a Hospital </Form.Label>
                                <Form.Select aria-label="Default select example">
                                    <option>Select a Hospital</option>
                                    <option value="1">
                                        Antelope Valley Medical Center
                                    </option>
                                    <option value="2">MLK Jr Hospital</option>
                                    <option value="3">SCH-Culver City</option>
                                    <option value="4">
                                        Foothill Regional Medical Center
                                    </option>
                                    <option value="5">
                                        College Medical Center
                                    </option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>
                                    Select type of rotation{" "}
                                </Form.Label>
                                <Form.Select aria-label="Default select example">
                                    <option>Select type of rotation</option>
                                    <option value="1">Medical</option>
                                    <option value="2">Surgical</option>
                                    <option value="3">Mental Health</option>
                                    <option value="4">Pediatrics</option>
                                    <option value="5">OB</option>
                                    <option value="6">Preceptorships</option>
                                    <option value="7">other</option>
                                </Form.Select>
                            </Form.Group>
                            <h6 className="fldgp_hdng mt-4 mb-3">
                                Choose dates to book Hospital
                            </h6>
                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                >
                                    <Form.Label>Start Date</Form.Label>
                                    <DatePicker
                                        value={value1}
                                        placeholder="Enter Start Date"
                                        className="form-control"
                                        onChange={(newValue) => {
                                            setValue1(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </Form.Group>

                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                >
                                    <Form.Label>End Date</Form.Label>
                                    <DatePicker
                                        value={value1}
                                        placeholder="Enter Start Date"
                                        className="form-control"
                                        onChange={(newValue) => {
                                            setValue1(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </Form.Group>

                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                >
                                    <Form.Label>Start Time</Form.Label>
                                    <TimePicker
                                        value={value2}
                                        className="form-control"
                                        onChange={(newValue) => {
                                            setValue2(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </Form.Group>

                            <Form.Group
                                controlId="formFile"
                                className="mb-3 mui_dtpickr"
                            >
                                <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                >
                                    <Form.Label>End Time</Form.Label>
                                    <TimePicker
                                        value={value2}
                                        className="form-control"
                                        onChange={(newValue) => {
                                            setValue2(newValue);
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} />
                                        )}
                                    />
                                </LocalizationProvider>
                            </Form.Group>

                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>
                                    What are your Course objectives?
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Write your message here"
                                />
                            </Form.Group>
                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Your Message</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={4}
                                    placeholder="Write your message here"
                                />
                            </Form.Group>
                            <div className="text-center">
                                <Button
                                    className="btn_theme mt-4"
                                    type="submit"
                                    variant=""
                                    href="/admin-approval"
                                >
                                    Submit Request
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default PendingApproval;
